import { GET_BIKE_MODEL_REQUEST, GET_BIKE_MODEL_REQUEST_SUCCESS, GET_BIKE_MODEL_REQUEST_FAILURE } from '../constants/get_bike_model.constants';

const prefix = 'GET'; const
    item = 'MODEL';
export const getBikeModelRequest = model_id => ({
    type: GET_BIKE_MODEL_REQUEST, model_id, prefix, item,
});

export const getBikeModelRequestSuccess = payload => ({
    type: GET_BIKE_MODEL_REQUEST_SUCCESS, payload,
});

export const getBikeModelRequestFailure = error => ({
    type: GET_BIKE_MODEL_REQUEST_FAILURE, error, prefix, item,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/actions/get_bike_model.actions.js